import React from 'react';
import MaterialChip from '@material-ui/core/Chip';
import { useIntl } from 'react-intl';
import { useStyles } from './styles';
import { translateLabel } from '../../../utils/translateLabel';
import InfoIcon from '@material-ui/icons/Info';
import { Tooltip } from '@material-ui/core';

export enum ConsentChipStyleEnum {
  SUCCESS = 'success',
  PRIMARY = 'primary',
  ERROR = 'error',
  DEFAULT = 'default',
}

export type ConsentChipPropsType = {
  label: string;
  style: ConsentChipStyleEnum;
  helper?: string;
};

function ConsentChip(props: ConsentChipPropsType) {
  const { label, helper, style } = props;
  const classes = useStyles();
  const styles: React.CSSProperties = {};
  switch (style) {
    case 'success':
      styles.color = '#04844B';
      styles.backgroundColor = '#E6F3EC';
      break;
    case 'error':
      styles.color = '#b10b1e';
      styles.backgroundColor = '#ed7474';
      break;
    case 'primary':
      styles.color = '#2673A9';
      styles.backgroundColor = '#E8F3FD';
      break;
    case 'default':
      styles.color = '#000';
      styles.backgroundColor = '#FFF7ED';
      break;
  }

  const intl = useIntl();
  if (!label) {
    return null;
  }
  return (
    <div className={classes.wrapper}>
      <MaterialChip label={translateLabel(intl, label)} className={classes.chip} style={styles} />
      {!!helper && (
        <Tooltip title={helper}>
          <InfoIcon style={{ fontSize: '1rem', color: '#999' }} />
        </Tooltip>
      )}
    </div>
  );
}

export default ConsentChip;
